import BasicModel from '../basic/BasicModel'

export default {
  authInsuranceOrder (vm, params, listener) {
    let action = 'lcwpInsurance/authInsuranceOrder.action'
    BasicModel.post(vm, action, params, listener)
  },
  saveRewardMungBean (vm, params, listener) {
    let action = 'lcwpInsurance/saveRewardMungBean.action'
    BasicModel.post(vm, action, params, listener)
  },
  saveDeductionMungBean (vm, params, listener) {
    let action = 'lcwpInsurance/saveDeductionMungBean.action'
    BasicModel.post(vm, action, params, listener)
  },
  findMyMungBean (vm, params, listener) {
    let action = 'lcwpInsurance/findMyMungBean.action'
    BasicModel.get(vm, action, params, listener)
  },
  findMyInsuranceOrderList (vm, params, listener) {
    let action = 'lcwpInsurance/findMyInsuranceOrderList.action'
    BasicModel.get(vm, action, params, listener)
  }
}
